import config from 'api/config';

export const loadImage = (src) =>
  new Promise((resolve) => {
    const loader = new Image();
    loader.onload = resolve;
    loader.src = src;
    // Failsafe
    setTimeout(resolve, 1000);
  });

export const getUserTimeZone = () => {
  const today = new Date();
  const dateStr = today.toLocaleDateString('en-GB', {
    timeZone: Intl.DateTimeFormat('en-GB').resolvedOptions().timeZone,
    timeZoneName: 'short',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  });
  return dateStr.split(', ')[1];
};

export const toggleScrollLock = (isLocked) => {
  const $body = document.querySelector('body');
  if (isLocked) {
    $body.style.overflow = 'hidden';
    $body.style.height = '100vh';
  } else {
    $body.style.removeProperty('overflow');
    $body.style.removeProperty('height');
  }
};

export function sortComponents(startIndex, components) {
  const sortedComponents = components
    .slice(startIndex)
    .concat(components.slice(0, startIndex));
  return sortedComponents;
}

export const getMobileOperatingSystem = () => {
  // https://stackoverflow.com/a/21742107/2250505
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
};

export const getMobileAppLink = () => {
  const os = getMobileOperatingSystem();
  if (os === 'iOS') {
    return 'https://apps.apple.com/us/app/safetywing/id1574203583';
  }
  return 'https://play.google.com/store/apps/details?id=com.safetywing.nomadinsurance';
};

export const internalRedirect = (path, routeProps) => {
  const search = routeProps?.location?.search ? routeProps.location.search : '';
  window.location.href = `${config.appUrl}${path}${search}`;
  return null;
};
